import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Truck, Package } from 'lucide-react';
import TruckSchedulerSidebar from './TruckSchedulerSidebar';
import { useAuth } from '../../../../context/AuthContext';
import UserMenu from '../../../../components/UserMenu';
import AnnouncementBanner from '../../../../components/announcements/AnnouncementBanner';

// Define consistent theme colors
const THEME_COLORS = {
  inbound: {
    color: 'blue-400',
    bg: 'blue-600',
    lightBg: 'blue-600/10',
    icon: Truck
  },
  outbound: {
    color: 'green-400',
    bg: 'green-600',
    lightBg: 'green-600/10',
    icon: Package
  }
};

const TruckSchedulerLayout = ({ children, mode }) => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  
  // Determine mode from props or URL if not specified
  const effectiveMode = mode || (location.pathname.includes('/truck_scheduler/outbound') ? 'outbound' : 'inbound');
  
  // Get theme properties based on mode
  const themeProperties = THEME_COLORS[effectiveMode] || THEME_COLORS.inbound;
  const { icon: Icon, color: iconColor } = themeProperties;
  
  // Set title based on mode
  const title = effectiveMode === 'inbound' 
    ? 'Truck Scheduler: Inbound Operations' 
    : 'Truck Scheduler: Outbound Operations';

  return (
    <div className="flex flex-col lg:flex-row min-h-screen bg-slate-900">
      <TruckSchedulerSidebar mode={effectiveMode} />
      <div className="flex-1 w-full lg:w-auto lg:ml-64">
        <header className="bg-slate-800 border-slate-700 border-b sticky top-0 z-30">
          <div className="px-6 py-4 flex justify-between items-center">
            <h1 className="text-xl font-semibold text-slate-200 ml-12 lg:ml-0 flex items-center min-w-0">
              <Icon className={`w-5 h-5 mr-2 flex-shrink-0 text-${iconColor}`} />
              <span className="truncate">{title}</span>
            </h1>
            <AnnouncementBanner />
            {/* User menu */}
            <div className="flex items-center gap-4 flex-shrink-0">
              <UserMenu isDarkMode={true} />
            </div>
          </div>
        </header>
        <main className="p-4 lg:p-6">
          {children}
        </main>
      </div>
    </div>
  );
};

export default TruckSchedulerLayout;